import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Navigation, Scrollbar } from 'swiper';
import { useLang } from '@/i18n';

const IndustryLeadingE = forwardRef((props, ref) => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingE');
    const swiperRef = useRef<any>(null);
    const [activeIndex, setactiveIndex] = useState();
    useImperativeHandle(ref, () => ({
        changeTwoItem: (index: number) => {
            toggleItemHandle('', index);
            setactiveIndex(index);
        },
    }));
    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
        {
            tabLabel: t('tab_3'),
            tabValue: 'c',
        },
        {
            tabLabel: t('tab_4'),
            tabValue: 'd',
        },
    ];

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756985026033/industry-e-1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1756985026033/industry-e-1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1757386534682/industry-e-1-m.jpg',
            desc: t('desc_1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756985026226/industry-e-2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1756985026226/industry-e-2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1757386533904/industry-e-2-m.jpg',
            desc: t('desc_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756985026421/industry-e-3-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1756985026421/industry-e-3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1757386534341/industry-e-3-m.jpg',
            desc: t('desc_3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757936128809/4%20(1)%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1757936128809/4%20(1)%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1757936128681/%E3%82%B9%E3%83%9E%E3%83%BC%E3%83%88%E5%88%B6%E5%BE%A1%20%26%20%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%AF%E3%82%99%20(1).jpg',
            desc: t('desc_4'),
        },
    ];

    const [activeItem, setActiveItem] = useState<any>(contentList[0]);

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentList[index]);
        swiperRef.current.slideToLoop(index);
    };
    // 轮播组件内的切换
    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveItem(contentList[index]);
        swiperRef.current?.slideToLoop(index);
        setactiveIndex(index);
    };

    return (
        <section className={`${styles.IndustryLeadingE} GtmModuleData-section`} id="IndustryLeadingE" data-section-id={'IndustryLeadingE'}>
            <div className="industry-bg-wrap">
                <div className="industry-content">
                    <div className="industry-swiper">
                        <Swiper
                            modules={[Navigation]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            loop={true}
                            centeredSlides={true}
                            spaceBetween={16}
                            slidesPerView={'auto'}
                            onSlideChange={handleSlideChange}
                        >
                            {contentList.map((item, index) => (
                                <SwiperSlide key={index} className="industry-swiper-slide">
                                    <EcoImg isOpenLazy className="industry-swiper-img" pc={item.pc} pad={item.pad} h5={item.h5} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className={`industry-content-tab`}>
                        <EcoTab onChange={toggleItemHandle} activeIndex={activeIndex} items={items} theme={'white'} />
                    </div>
                    <div className="industry-desc">{activeItem.desc}</div>
                </div>
            </div>
        </section>
    );
});

export default IndustryLeadingE;
